import { Injectable } from '@angular/core';
import { AbstractDispatcherAction, AbstractDispatcherService } from 'buzzyears.ui';

export enum WorkflowDesignerDispatcherActionType {
  ElementsPanelShowRequest = 'elements-panel-show-request',
  ElementsPanelHideRequest = 'elements-panel-hide-request',
  PropertiesPanelShowRequest = 'properties-panel-show-request',
  PropertiesPanelHideRequest = 'properties-panel-hide-request',

  LibraryViewRequest = 'library-view-request',
  TestViewRequest = 'test-view-request',

  VertexAddRequest = 'vertex-add-request',
  VertexAdded = 'vertex-added',
  VertexSelectRequest = 'vertex-select-request',
  VertexSelected = 'vertex-selected',
  MultiVertexSelected = 'multi-vertex-selected',
  VertexPropertiesUpdated = 'vertex-properties-updated',
  VertexRemoveRequest = 'vertex-remove-request',
  VertexRemoved = 'vertex-removed',

  EdgeAddRequest = 'edge-add-request',
  EdgeAdded = 'edge-added',
  EdgeRemoveRequest = 'edge-remove-request',
  EdgeRemoved = 'edge-removed',
  EdgeMoveRequest = 'edge-move-request',
  EdgeMoved = 'edge-moved',

  WorkflowTestRequest = 'workflow-test-request',
  WorkflowTested = 'workflow-tested',
}

export interface WorkflowDesignerDispatcherAction extends AbstractDispatcherAction {
  type: WorkflowDesignerDispatcherActionType;
  data?: any;
}

@Injectable()
export class WorkflowDesignerDispatcherService extends AbstractDispatcherService<WorkflowDesignerDispatcherAction> {
  dispatchAction(type: WorkflowDesignerDispatcherActionType, originator: any = null, data: any = null) {

    if (!type) {
      // Do nothing...
      return;
    }

    this.dispatch({
      type: type,
      originator: originator,
      data: data
    });
  }
}



// WEBPACK FOOTER //
// ./src/library/designer/workflow-designer-dispatcher.service.ts